import {
  ref, onMounted, onUnmounted,
} from 'vue';

export const useContentLoaded = () => {
  const isContentLoaded = ref(false);

  const checkReadyState = () => {
    if (document.readyState === 'complete') {
      isContentLoaded.value = true;
    }
  };

  onMounted(() => {
    checkReadyState();
    // Fallback
    window.addEventListener('load', checkReadyState);
  });

  onUnmounted(() => {
    window.removeEventListener('load', checkReadyState);
  });

  return { isContentLoaded };
};
